<div class="c-table-budget">
    @defer (when !loading()) {
        <div
            class="c-table-budget__container poisition-sticky-left"
            style="overflow-y: auto"
            fxLayout="column"
        >
            <table class="c-table-budget__table">
                <thead class="c-table-budget__header">
                    <tr>
                        <th
                            [class.header-mobile]="isMobile()"
                            [class.header-desktop]="!isMobile()"
                            [class.header-pdf]="pdfMode()"
                            class="c-table-budget__header-cell c-table-budget__header-cell--account"
                        ></th>
                        <th colspan="12" [class.text-mobile]="isMobile()">
                            <span
                                [class.text-12-semi-bold]="!pdfMode()"
                                [class.text-8-semi-bold]="pdfMode()"
                                style="
                                    color: var(--color-text-hint) !important;
                                    padding-bottom: var(--spacing-8);
                                "
                                >{{ options()?.scenario?.props?.name }}</span
                            >
                        </th>
                    </tr>
                    <tr>
                        <th
                            [class.header-mobile]="isMobile()"
                            [class.header-desktop]="!isMobile()"
                            [class.header-pdf]="pdfMode()"
                            class="c-table-budget__header-cell c-table-budget__header-cell--account sticky-last"
                        ></th>
                        <ng-container *ngFor="let month of months">
                            <th
                                [class.header-month-mobile]="isMobile()"
                                [class.header-month-desktop]="!isMobile()"
                                [class.header-month-pdf]="pdfMode()"
                                class="c-table-budget__header-cell c-table-budget__header-cell--month sticky-last"
                            >
                                <div fxLayout="column" style="padding: 0px 4px">
                                    <div
                                        fxLayout="column"
                                        fxLayoutAlign="center center"
                                        [class.c-table-budget__original-pdf]="
                                            pdfMode()
                                        "
                                        class="c-table-budget__header-cell-content"
                                    >
                                        <span
                                            [class.text-12-semi-bold]="
                                                !pdfMode()
                                            "
                                            [class.text-8-semi-bold]="pdfMode()"
                                            >{{ month }}</span
                                        >
                                    </div>
                                </div>
                            </th>
                        </ng-container>
                    </tr>
                </thead>

                <tbody class="c-table-budget__body">
                    <tr
                        *ngFor="let item of visibleItems; let i = index"
                        class="c-table-budget__row"
                        (click)="toggleExpansion(item, $event)"
                        [attr.data-level]="item.metadata"
                        [class.last-row-table]="
                            getLastChildByMainParent(item) ||
                            getLastCompoundChild(item)
                        "
                    >
                        <!-- Account Name Column -->
                        <td
                            class="c-table-budget__cell c-table-budget__cell--account"
                        >
                            <div
                                fxLayout="column"
                                class="c-table-budget__column-p"
                                [class]="{
                                    'expanded-table':
                                        (item.metadata.isExpanded &&
                                            isGroup(item) &&
                                            isFromParentMain(item)) ||
                                        (item.metadata.isExpanded &&
                                            isGroup(item) &&
                                            isFromParentCoumpound(item)),
                                    'children-table':
                                        item.metadata.level > 2 ||
                                        isCompoundChildren(item),
                                    'last-child-important':
                                        getLastChildByMainParent(item) ||
                                        getLastCompoundChild(item)
                                }"
                            >
                                <div
                                    fxLayout="column"
                                    class="c-table-budget__columns"
                                    [class.pdf]="pdfMode()"
                                    [class.expanded-table]="
                                        (item.metadata.isExpanded &&
                                            isGroup(item) &&
                                            isFromParentMain(item)) ||
                                        (item.metadata.isExpanded &&
                                            isGroup(item) &&
                                            isFromParentCoumpound(item))
                                    "
                                    [class.child-table]="
                                        isCompoundChildren(item)
                                    "
                                    [ngClass]="getRowClass(i)"
                                    [ngStyle]="item.metadata.indentStyle"
                                >
                                    <div fxLayout="column">
                                        <div
                                            class="c-table-budget__account-content"
                                        >
                                            <span
                                                *ngIf="
                                                    item.metadata.hasChildren
                                                "
                                                class="c-table-budget__expand-icon {{
                                                    item.serie.props?.highlight
                                                        ?.bold &&
                                                        'bold-highlight'
                                                }}"
                                                [ngClass]="{
                                                    'c-table-budget__expand-icon--expanded':
                                                        item.metadata.isExpanded
                                                }"
                                                [class.text-12-regular]="
                                                    !pdfMode()
                                                "
                                                [class.text-8-regular]="
                                                    pdfMode()
                                                "
                                            >
                                                @if (!pdfMode()) {
                                                    <i
                                                        [class]="
                                                            item.metadata
                                                                .isExpanded
                                                                ? 'fas fa-caret-down'
                                                                : 'fas fa-caret-right'
                                                        "
                                                        style="
                                                            font-size: var(
                                                                --font-size-14
                                                            );
                                                            margin-right: var(
                                                                --spacing-8
                                                            );
                                                        "
                                                    ></i>
                                                }
                                            </span>
                                            <span
                                                [class.text-8-regular]="
                                                    pdfMode()
                                                "
                                                [class.text-12-regular]="
                                                    !pdfMode()
                                                "
                                                class="c-table-budget__account-name {{
                                                    item.serie.props?.highlight
                                                        ?.bold &&
                                                        'bold-highlight'
                                                }}"
                                                >{{ item.serie.props.name }}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </td>

                        <!-- Data Columns -->
                        <ng-container *ngFor="let month of item.columns">
                            <td
                                class="c-table-budget__cell c-table-budget__cell--data"
                                [class.text-8-regular]="!pdfMode()"
                                [class.text-12-regular]="pdfMode()"
                            >
                                <div
                                    fxLayout="column"
                                    class="c-table-budget__column-p full-width full-height"
                                    [class]="{
                                        'expanded-table':
                                            (item.metadata.isExpanded &&
                                                isGroup(item) &&
                                                isFromParentMain(item)) ||
                                            (item.metadata.isExpanded &&
                                                isGroup(item) &&
                                                isFromParentCoumpound(item)),
                                        'children-table':
                                            item.metadata.level > 2 ||
                                            isCompoundChildren(item),
                                        'last-child-important':
                                            getLastChildByMainParent(item) ||
                                            getLastCompoundChild(item)
                                    }"
                                >
                                    <div
                                        fxLayout="column"
                                        class="c-table-budget__columns full-height"
                                        [class.pdf]="pdfMode()"
                                        [class.expanded-table]="
                                            (item.metadata.isExpanded &&
                                                isGroup(item) &&
                                                isFromParentMain(item)) ||
                                            (item.metadata.isExpanded &&
                                                isGroup(item) &&
                                                isFromParentCoumpound(item))
                                        "
                                        [class.child-table]="
                                            isCompoundChildren(item)
                                        "
                                        fxLayoutAlign="center center"
                                        [ngClass]="getRowClass(i)"
                                    >
                                        <div
                                            fxLayout="column"
                                            class="full-height"
                                            fxLayoutAlign="center center"
                                        >
                                            <span
                                                class="c-table-budget__original {{
                                                    item.serie.props?.highlight
                                                        ?.bold &&
                                                        'bold-highlight'
                                                }}"
                                                [class.text-8-regular]="
                                                    pdfMode()
                                                "
                                                [class.text-12-regular]="
                                                    !pdfMode()
                                                "
                                                >{{
                                                    month.original
                                                        .pointValueFormatted
                                                }}</span
                                            >
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </ng-container>
                    </tr>
                </tbody>
            </table>
        </div>
    } @placeholder {
        <dsn-skeleton-loader
            [type]="'rectangle'"
            [width]="'100%'"
            [height]="'38px'"
        ></dsn-skeleton-loader>
    }
</div>
